import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [categories, setCategories] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo canal de incentivo`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'sale/canal-incentivo'}
      >
        <>
          <TextField
            label="codigo"
            fullWidth
            type="text"
            name="code"
            margin="normal"
            value={dataChanging.code || ''}
            onChange={(e) => handleChange('code', e.target.value)}
            required
          />
          <TextField
            label="Descripción"
            fullWidth
            type="text"
            name="description"
            margin="normal"
            value={dataChanging.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            required
          />
        </>
      </Modal>
    </>
  );
});
